import { jsx as _jsx } from "react/jsx-runtime";
import { CircularLoader } from 'seagull';
import { RichTextViewer } from 'seagull/components/RichTextViewer';
import { EMPTY_QUILL_DELTA } from 'seagull/utils/richText';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCustomPageText } from '~/hooks/reactQuery/queries/useCustomPageText';
export const GetCustomPageTextViewerTID = (parentTestId)=>getTestIds(parentTestId);
export function CustomPageTextViewer(param) {
    let { sourceId, textId, testId } = param;
    const { content, isLoading } = useCustomPageText({
        sourceId,
        textId
    });
    const testIds = GetCustomPageTextViewerTID(testId);
    if (isLoading) {
        return /*#__PURE__*/ _jsx(CircularLoader, {
            size: 32,
            testId: testIds.CustomPageTextViewerTestIds.Loader()
        });
    }
    return /*#__PURE__*/ _jsx(RichTextViewer, {
        value: content !== null && content !== void 0 ? content : EMPTY_QUILL_DELTA,
        testId: testIds.CustomPageTextViewerTestIds.Viewer()
    });
}
